module.exports = __webpack_public_path__ + "img/pubgm.63c4aad.jpg";